import { useVirtualizer, type Virtualizer } from '@tanstack/react-virtual';
import { useRef, type RefObject } from 'react';
import { type OptimisticMessage } from '@avanta/shared/types/chat';

const VIRTUALIZATION_THRESHOLD = 100;
const DEFAULT_ESTIMATED_SIZE = 80;
const DEFAULT_OVERSCAN = 10;

interface UseMessageVirtualizerResult {
  scrollContainerRef: RefObject<HTMLDivElement | null>;
  virtualizer: Virtualizer<HTMLDivElement, Element>;
  shouldVirtualize: boolean;
}

export const useMessageVirtualizer = (
  messages: OptimisticMessage[]
): UseMessageVirtualizerResult => {
  const scrollContainerRef = useRef<HTMLDivElement>(null);
  const shouldVirtualize = messages.length > VIRTUALIZATION_THRESHOLD;

  const virtualizer = useVirtualizer({
    count: shouldVirtualize ? messages.length : 0,
    getScrollElement: () => scrollContainerRef.current,
    estimateSize: () => DEFAULT_ESTIMATED_SIZE,
    overscan: DEFAULT_OVERSCAN,
  });

  return { scrollContainerRef, virtualizer, shouldVirtualize };
};
